import { mapMenus } from '@/utils/utils'
import store from '../index'

const state = {
  infoIcon: {
    total_activated_students: 'student',
    total_classes: 'classNum',
    total_works: 'info',
    avarage_score: 'score',
    high_score: 'highest',
    behavior_score: 'highest'
  },
  scoreName: {
    total_teachers: '教师数',
    total_classes: '班级数',
    activated_students: '激活学生数',
    total_periods: '上课数',
    total_works: '作品数',
    average_score: '作品平均分',
    high_score: '作品最高分',
    behavior_score: '课堂表现'
  },
  scoreUrl: {},
  unit: {
    unit_count: '所',
    teacher_count: '位',
    class_count: '个',
    activat_student_count: '位',
    attend_class_count: '节',
    work_count: '个'
  },
  unitTextColor: {
    unit_count: '#E4053C',
    teacher_count: '#F75F07',
    class_count: '#188C00',
    activat_student_count: '#1AAE9B',
    attend_class_count: '#007AFB',
    work_count: '#5908D1'
  },
  unit_scoreName: {
    unit_count: '学校数',
    teacher_count: '教师数',
    class_count: '班级数',
    activat_student_count: '激活学生数',
    attend_class_count: '上课数',
    work_count: '作品总数',
    teacher_increased_count: '昨日新增教师数',
    student_increased_count: '昨日新增学生数',
    class_increased_count: '昨日新增班级数',
    consume_voucher_count: '消耗券',
    give_voucher_count: '赠送券',
    purchase_voucher_count: '购买券',
    coupons_voucher_count: '返券',
    refund_voucher_count: '退款券'
  },
  // unit_background: {
  //   unit_count: 'linear-gradient(332deg, #C21A8A 0%, #D2622B 100%)',
  //   teacher_count: 'linear-gradient(332deg, #B14200 0%, #CA8800 100%)',
  //   class_count: 'linear-gradient(332deg, #2B8918 0%, #73B20B 100%)',
  //   activat_student_count: 'linear-gradient(332deg, #00815D 0%, #0BC889 100%)',
  //   attend_class_count: 'linear-gradient(332deg, #134F90 0%, #25A1C0 100%)',
  //   work_count: 'linear-gradient(332deg, #5211A4 0%, #396EE4 100%)'
  // },
  unit_icon: {
    unit_count: 'https://public-static-edu.codemao.cn/redboat/dashboard/new_school.png',
    teacher_count: 'https://public-static-edu.codemao.cn/redboat/dashboard/new_teacher.png',
    class_count: 'https://public-static-edu.codemao.cn/redboat/dashboard/new_class.png',
    activat_student_count: 'https://public-static-edu.codemao.cn/redboat/dashboard/new_student.png',
    attend_class_count: 'https://public-static-edu.codemao.cn/redboat/dashboard/new_class_number.png',
    work_count: 'https://public-static-edu.codemao.cn/redboat/dashboard/new_works.png'
  },
  unit_icon_position: {
    unit_count: '35%, auto',
    teacher_count: '40%, auto',
    class_count: '40%, auto',
    activat_student_count: '48%, auto',
    attend_class_count: '33%, auto',
    work_count: '40%, auto'
  },
  menuName: {
    dashboard: '100000-190000-270000-330000',
    teacherManage: '110000-0-0-0',
    classManage: '120000-200000-0-0',
    studentManage: '130000-210000-0-0',
    tool: '150000-230000-290000-0',
    headEntry: '370000-440000-480000-0'
  },
  menuRouter: {
    // 角色：10001教管 - 10002教师 - 20001学生 - 40001代理
    '100000-190000-270000-330000': 'dashboard', // 平台首页
    '510000-500000-490000-0': 'courseTeaching', // 课程教学
    '110000-0-0-0': 'teacherManage', // 教师管理
    '120000-200000-0-0': 'classManage', // 班级管理
    '130000-210000-0-0': 'studentManage', // 学生管理
    '140000-220000-0-0': 'courseManage', // 课程中心
    '150000-230000-290000-0': 'tool', // 创作工具
    '160000-240000-0-0': 'workManage', // 作品管理
    '170000-250000-310000-0': 'learningStatistics', // 学情报告
    '180000-260000-320000-0': 'help', // 帮助与反馈
    '0-0-270200-0': 'studentForum', // 学生社区
    '0-0-280000-0': 'courseManage', // 我的课程
    '0-0-300000-0': 'myWork', // 我的作品
    // '0-0-0-340000': 'unitManage', // 单位管理
    '0-0-0-340000': 'enterSchool', // 进校业务
    '0-0-0-350000': 'B2C', // 消费者跟进
    '0-0-0-360000': 'schoolApply', // 学校申请
    '100100-190100-270100-0': 'tower', // 源码练习
    '100200-190200-0-0': 'forum', // 教师论坛
    '100300-190300-270300-0': 'offlineTool', // 离线创作工具
    '100400-190400-270400-0': 'contestCenter', // 赛事中心
    '100500-190500-270500-0': 'mlz', // 双师课堂
    '510100-510200-0-0': 'courseIntro' // 课程体系介绍
  },
  menuIcon: {
    '100000-190000-270000-330000': '-2px -2px',
    '110000-0-0-0': '-2px -30px',
    '120000-200000-0-0': '-2px -58px',
    '130000-210000-0-0': '-2px -86px',
    '140000-220000-0-0': '-2px -113px',
    '150000-230000-290000-0': '-2px -140px',
    '160000-240000-0-0': '-2px -196px',
    '170000-250000-310000-0': '-2px -225px',
    '180000-260000-320000-0': '-2px -168px',
    '0-0-280000-0': '-2px -113px',
    '0-0-300000-0': '-2px -196px',
    '0-0-0-340000': '-2px -334px',
    '0-0-0-350000': '-2px -306px',
    '0-0-0-360000': '-2px -276px',
    '100100-190100-270100-0': '-2px -250px'
  },
  menu: [],
  entry: [],
  scoreBoard: [],
  entryBackground: {
    '110000-0-0-0': 'linear-gradient(-222deg, #4BE28E 0%, #00C4AA 100%)',
    '120000-200000-0-0': 'linear-gradient(-222deg, #FF9E2D 0%, #FF721C 100%)',
    '130000-210000-0-0': 'linear-gradient(-222deg, #FFE155 0%, #FFBB11 100%)',
    '140000-220000-0-0': 'linear-gradient(-222deg, #FFD1B8 0%, #FFAC61 100%)',
    '150000-230000-290000-0': 'linear-gradient(-222deg, #5EDEEF 0%, #40BCEA 100%)',
    '160000-240000-0-0': 'linear-gradient(-222deg, #F69EE9 0%, #DC6CC4 100%)',
    '170000-250000-310000-0': 'linear-gradient(-222deg, #4CEBC9 0%, #10CAEA 100%)',
    '0-0-270200-0': 'linear-gradient(332deg, #F3A161 0%, #FFDC47 100%)',
    '0-0-280000-0': 'linear-gradient(-222deg, #FFD1B8 0%, #FFAC61 100%)',
    '0-0-300000-0': 'linear-gradient(-222deg, #F69EE9 0%, #DC6CC4 100%)',
    '100100-190100-270100-0': 'linear-gradient(332deg, #009AFF 0%, #66B8FF 100%)',
    '100200-190200-0-0': 'linear-gradient(-222deg, #98EB5B 0%, #79C342 100%)',
    '100300-190300-270300-0': 'linear-gradient(332deg, #02A77A 0%, #17E9A3 100%)',
    // '100400-190400-270400-0': 'url("https://education.codemao.cn/27/eduzone/1/dashboard/1608727313000/noc.png") no-repeat right bottom, linear-gradient(332deg, #5524DD 0%, #449FFE 100%)',
    '100400-190400-270400-0': 'url("") no-repeat right bottom, linear-gradient(332deg, #5524DD 0%, #449FFE 100%)', // 去除noc图标的版本
    '100500-190500-270500-0': 'url("https://education.codemao.cn/27/eduzone/1/dashboard/1608727185000/ai.png") no-repeat 100%/cover',
    '510100-510200-0-0': 'url("https://education.codemao.cn/27/eduzone/1/courseIntro.png") no-repeat 100%/cover'
  },
  entryCornerIcon: {
    '160000-240000-0-0': 'https://public-static-edu.codemao.cn/redboat/dashboard/newCornerIcon.png'
  },
  entryIconPosition: {
    '110000-0-0-0': '-30px -2px',
    '120000-200000-0-0': '-30px -98px',
    '130000-210000-0-0': '-30px -50px',
    '140000-220000-0-0': '-30px -194px',
    '150000-230000-290000-0': '-30px -242px',
    '160000-240000-0-0': '-30px -146px',
    '170000-250000-310000-0': '-30px -340px',
    '0-0-270200-0': '-30px -385px',
    '0-0-280000-0': '-30px -194px',
    '0-0-300000-0': '-30px -146px',
    '100100-190100-270100-0': '-30px -435px',
    '100200-190200-0-0': '-30px -385px',
    '100300-190300-270300-0': '-30px -290px',
    '100400-190400-270400-0': '-30px -482px'
  },
  headEntry: {
    '370100-440100-480100': 'discuss',
    '370200-440200-480200': 'nemo',
    '370300-440300-480300': 'parent'
  },
  blackboard: null,
  tempMenus: [],
  showModal: false,
  helpRed: ''
}

Object.defineProperty(state.scoreUrl, 'total_works', {
  get () {
    return store && store.getters.roleType === 'student'
      ? 'myWork'
      : 'workManage'
  },
  enumerable: true
})

// actions
const actions = {
  // 获取菜单
  async getMenu ({ commit, rootState }) {
    let res
    if (store.state.customInfo) {
      // 定制教室的菜单
      res = await API.get('/edu/zone/homepage/menus', {
        url: JSON.parse(localStorage.getItem('customInfo')).url
        // 本地调试科协(全局搜索本段文字，还需修改一个位置)
        // url: 'https://dev-teacher.edu.codemao.cn/xxpt'
      })
    } else {
      res = await API.get('/edu/zone/homepage/menus')
    }
    state.tempMenus = res.data.menus
    localStorage.setItem('menus', JSON.stringify(state.tempMenus))
    commit('setMenu', res.data)
  },

  // 获取首页信息
  async getRecentRecord ({ commit, rootState }) {
    const unitId = rootState.user.role_id
    if (unitId === 40001) {
      const res = await API.get('/edu/zone/channel/agent/operation/records')
      if (res.status < 400 && res.data.status) {
        commit('SET_BLACKBOARD_LIST', res.data.items)
      }
    } else {
      const res = await API.get('/edu/zone/operation/records')
      if (res.status < 400 && res.data.status) {
        commit('SET_BLACKBOARD_LIST', res.data.items)
      }
    }
  },
  // 获取基础统计信息
  async getStatistic ({ commit, rootState }) {
    const unitId = rootState.user.role_id
    if (unitId === 40001) {
      // 获取统计基础数据
      const res = await API.get(
        '/edu/zone/homepage/channel/agent/base/statistic'
      )
      if (res.status < 400) {
        commit('setStatistic', res.data)
        const increaseRes = await API.get(
          '/edu/zone/homepage/channel/agent/increase/statistic'
        )
        if (increaseRes.status < 400) {
          commit('setIncreaseStatistic', increaseRes.data)
        }
      }
    } else {
      const res = await API.get('/edu/zone/homepage/statistic')
      if (res.status < 400) {
        commit('setStatistic', res.data.statistics)
      }
    }
  },
  // 获取消费统计数据
  async getVoucherStatistic ({ commit, rootState }) {
    const unit_id = rootState.user.role_id
    if (unit_id === 40001) {
      const res = await API.get(
        '/edu/zone/homepage/channel/agent//voucher/statistic'
      )
      if (res.status < 400) {
        commit('setVoucherStatistic', res.data)
      }
    }
  },
  // 获取操作指南红点信息
  async getHelpRedInfo ({ commit }) {
    const { status, data } = await API.get('/edu/zone/user-extend/info')
    if (status < 400) {
      commit('SET_HELPRED', data.helpRedFlag)
    }
  },
  // 更新操作指南红点信息
  async updateHelpRed({ commit }) {
    const { status } = await API.post('/edu/zone/user-extend/read-help-red')
    if (status < 400) {
      commit('SET_HELPRED', 1)
    }
  }
}

// mutations
const mutations = {
  setMenu (state, data) {
    state.menu = []
    const menu = data.menus
    // 如果用户在后台只选中B2C业务，需要屏平台首页
    if (menu.length === 2 && menu[1].custom_menu_id === 350000) menu.shift(menu)
    // 设置nav菜单
    menu.forEach(value => {
      if (state.menuName.headEntry.indexOf(value.custom_menu_id) === -1) { // 跳过顶部快捷入口
        const path = mapMenus(state.menuRouter, value)
        const position = mapMenus(state.menuIcon, value)
        state.menu.push({
          name: value.custom_menu_name,
          path: path,
          position: position
        })
      }
    })
    // 设置快捷入口
    state.entry = []
    menu.forEach(value => {
      if (state.menuName.dashboard.indexOf(value.custom_menu_id) === -1) return
      value.sub_menus.map(row => {
        const path = mapMenus(state.menuRouter, row)
        const background = mapMenus(state.entryBackground, row)
        const position = mapMenus(state.entryIconPosition, row)
        const cornerIcon = mapMenus(state.entryCornerIcon, row)
        state.entry.push({
          name: row.custom_menu_name,
          path: path,
          background: background,
          position: position,
          cornerIcon: cornerIcon
        })
      })
    })
  },
  setStatistic (state, data) {
    state.scoreBoard = []
    if (typeof data === 'object') {
      const unit_id = store.state.user.role_id
      if (unit_id === 40001) {
        Object.keys(data).forEach(key => {
          state.scoreBoard.push({
            name: state.unit_scoreName[key],
            icon: state.infoIcon[key],
            value: data[key],
            unit: state.unit[key],
            unitTextColor: state.unitTextColor[key],
            url: state.scoreUrl[key],
            // background: state.unit_background[key],
            backgroundIcon: state.unit_icon[key],
            backgroundIconPosition: state.unit_icon_position[key]
          })
        })
      } else {
        Object.keys(data).forEach(key => {
          state.scoreBoard.push({
            name: state.scoreName[key],
            icon: state.infoIcon[key],
            value: data[key],
            url: state.scoreUrl[key]
          })
        })
      }
    }
  },
  setIncreaseStatistic (state, data) {
    if (typeof data === 'object') {
      // ['教师数', '班级数', '激活学生数']
      const addedYesterdayKey = ['teacher_increased_count', 'class_increased_count', 'student_increased_count']
      Object.keys(data).forEach((key, index) => {
        if (!addedYesterdayKey.includes(key)) {
          state.scoreBoard.push({
            name: state.unit_scoreName[key],
            icon: state.infoIcon[key],
            value: data[key],
            unit: state.unit[key],
            unitTextColor: state.unitTextColor[key],
            url: state.scoreUrl[key],
            // background: state.unit_background[key],
            backgroundIcon: state.unit_icon[key],
            backgroundIconPosition: state.unit_icon_position[key]
          })
        } else {
          state.scoreBoard[1].addedYesterdayName = data[addedYesterdayKey[0]]
          state.scoreBoard[2].addedYesterdayName = data[addedYesterdayKey[1]]
          state.scoreBoard[3].addedYesterdayName = data[addedYesterdayKey[2]]
        }
      })
    }
  },
  setVoucherStatistic (state, data) {
    if (typeof data === 'object') {
      Object.keys(data).forEach(key => {
        state.scoreBoard.push({
          name: state.unit_scoreName[key],
          icon: state.infoIcon[key],
          value: data[key],
          url: state.scoreUrl[key]
        })
      })
    }
  },
  SET_CUSTOM_MENUS (state, menuName) {
    for (const menu of state.menu) {
      if (menu.path === 'dashboard') {
        menu.name = menuName
      }
    }
  },
  SET_BLACKBOARD_LIST (state, blackboardList) {
    state.blackboard = blackboardList
  },
  SET_HELPRED (state, value) {
    state.helpRed = value
  }
  // 是否设置密码
}

export default {
  state,
  actions,
  mutations
}
